import styled from "styled-components";

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 500;
  font-family: "DM Sans";
`;

export const IndicePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5%;
  height: 30px;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  margin-right: 5px;
`;

export const TitlePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  height: 30px;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  padding: 0 10px;
`;
